import {Dispatch, FC, SetStateAction, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {CheckingModel} from '../../../../models/ckecking.model'
import {Button} from '../../../../../../components/UI/Button'
import {useReactToPrint} from 'react-to-print'
import React from 'react'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {
  downloadPDFCheckInOutService,
  sendEmailCheckInOutService,
} from '../../../../services/booking.service'
import moment from 'moment'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  checkOut: CheckingModel
  getChekings: () => void
}

type ComponentToPrintProps = {
  // Otras props específicas de tu componente
  checkOut: CheckingModel
}

const ComponentToPrint = React.forwardRef<HTMLDivElement, ComponentToPrintProps>(
  ({checkOut}, ref) => {
    return (
      <div ref={ref}>
        <div className='row'>
          <div className='col-6'>
            <div className='d-flex'>
              <h5 className='me-2'>Nro Reserva:</h5>
              <span>{checkOut.CodigoReserva}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Módulo:</h5>
              <span>{checkOut.Modulo}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Habitación:</h5>
              <span>{checkOut.Habitacion}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Cama:</h5>
              <span>{checkOut.CodigoCama}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Tipo de Cama:</h5>
              <span>{checkOut.CamaTipo}</span>
            </div>
          </div>
          <div className='col-6'>
            <div className='d-flex'>
              <h5 className='me-2'>Huesped:</h5>
              <span>{checkOut.HuespedDescripcion}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Tipo de Empresa:</h5>
              <span>{checkOut.TipoEmpresa}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Fecha de Inicio:</h5>
              <span>{checkOut.FechaInicio}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Fecha Fin:</h5>
              <span>{checkOut.FechaFin}</span>
            </div>
          </div>
        </div>
      </div>
    )
  },
)

const ModalCheckOutDetail: FC<Props> = ({show, setShow, checkOut, getChekings}) => {
  const handleClose = () => {
    setShow(false)
  }

  const componentRef = useRef<any | null>(null)
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const handleSendMail = async (reservaCamaId: string) => {
    try {
      const data = await sendEmailCheckInOutService(reservaCamaId, 'OUT')
      if (!data.data.error) {
        getSnackBarToast('Se envió el correo con éxito', 'success')
      } else {
        getSnackBarToast('Error interno, volver a intentarlo', 'error')
      }
    } catch (error) {}
  }

  const handleViewPdf = async (reservaCamaId: string) => {
    try {
      let dto = {
        reservaCamaId: reservaCamaId,
        tipo: 'OUT',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckOut-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getChekings()
      getSnackBar('Se descargó el documento con éxito', true)
    } catch (error) {
      getSnackBar('Hubo un error al descargar', false)
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Detalle CheckOut</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row mb-4'>
            <div className='d-flex'>
              <Button
                label='Enviar correo'
                classNameProp='me-3'
                onClick={() => handleSendMail(checkOut.ReservaCamaId)}
              />
              <Button
                label='Ver PDF'
                classNameProp='me-3'
                onClick={() => handleViewPdf(checkOut.ReservaCamaId)}
              />
              {/* <Button label='Imprimir' onClick={handlePrint} /> */}
            </div>
          </div>
          <hr className='divider' />
          <ComponentToPrint ref={componentRef} checkOut={checkOut} />
        </div>
      </div>
    </Modal>
  )
}

export {ModalCheckOutDetail}
